module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/vue-global-method-286.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/development/vue-global-method.md
// module id = 730
// module chunks = 218